var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { AbstractChartContent } from './abstract-chart-content';
import { getLocale, mapTZ2ChartIQTZ } from './utils/parse';
import { toggleBodyTheme } from './utils/browser';
import html2canvas from 'html2canvas';
var COMPARISON_SYMBOL = 'Comparison Symbol';
if (typeof CIQ !== 'undefined') {
    CIQ.alert = function (text) {
        console.log(text); // errors should appear here
    };
}
/**
 * Implementation of the chart content which uses directly and exposes the chart iq engine (new lib)
 * @class ChartEngineContent
 * @param {any} stx
 * @param {any} type
 * @param {any} inputs
 * @param {any} outputs
 * @param {any} parameters
 * @param {any} panel
 * @param {any} display
 */
var ChartEngineContent = /** @class */ (function (_super) {
    __extends(ChartEngineContent, _super);
    /**
     * @constructor
     * @param {any} containerDiv
     * @param {ChartContentConfig} config
     */
    function ChartEngineContent(containerDiv, config) {
        var _this = _super.call(this, containerDiv, config) || this;
        _this.initialized = false;
        /**
         * Saves the layout using the chart settings service, ls and backend, backend can be disable via   'centralStorageDisabled': true
         *
         * @param {any} obj
         * @private
         */
        _this._saveLayout = function (obj) {
            if (_this._chartContentConfig.saveLayout) {
                var chartLayout = obj.stx.exportLayout(true);
                if (chartLayout && JSON.stringify(chartLayout) !== JSON.stringify(_this._chartLayout)) {
                    _this._chartLayout = chartLayout;
                    _this._saveSettings(chartLayout);
                    localStorage.setItem(_this.chartSettingsKey, JSON.stringify(chartLayout));
                }
            }
        };
        _this._customRelativeInstrFN = function (stx, type, inputs, outputs, parameters, panel, display) {
            var sym;
            if (inputs) {
                sym = [(_this.defaultPriceRelativeInstrument + '').toUpperCase()];
                inputs.display = display;
            }
            var sd = CIQ.Studies.initializeFN(stx, type, inputs, outputs, parameters, panel);
            CIQ.Studies.fetchAdditionalInstruments(stx, sd, sym);
            return sd;
        };
        CIQ.alert = function (text) {
            console.log(text); // errors should appear here
        };
        if (!containerDiv) {
            console.error(containerDiv);
            throw Error('Chart container not valid!');
        }
        _this._containerDiv = containerDiv;
        _this._createStxx();
        return _this;
    }
    /**
     * Return all disabled studies based on what studies you would like to enable
     * @param {string[]} enabledStudies
     * @returns {any} disabledStudies
     */
    ChartEngineContent.getDisabledStudies = function (enabledStudies) {
        var disabledStudies = {};
        Object.keys(CIQ.Studies.studyLibrary).forEach(function (studyKey) {
            if (enabledStudies.indexOf(studyKey) === -1) {
                disabledStudies[studyKey] = true;
            }
        });
        return disabledStudies;
    };
    /**
     * Loops over the legend items and makes suggested adjustments
     * @param {any} stx
     * @param {any} params
     * @param {ReferenceData} referenceData
     */
    ChartEngineContent.suggestedLegendRenderer = function (stx, params, referenceData) {
        /* Loop over each legend item */
        Object.keys(params.legendColorMap).forEach(function (key) {
            // Current legend item
            var legendItem = params.legendColorMap[key];
            /**
             * adjust the display name of the main instrument
             */
            if (legendItem.isBase && referenceData) {
                legendItem.display = referenceData.name;
            }
        });
        // Continue with default renderer
        CIQ.drawLegend(stx, params);
    };
    /**
     * TODO document options
     * @inheritDoc
     */
    ChartEngineContent.prototype.init = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var hasStarted;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._dataHandler) {
                            return [2 /*return*/, Promise.reject(new Error('no data handler attached!'))];
                        }
                        if (!this._containerDiv) {
                            return [2 /*return*/, Promise.reject(new Error('error during initialization'))];
                        }
                        this.options = options;
                        if (this.options.idNotation) {
                            this._idNotation = this.options.idNotation;
                        }
                        if (this.options.priceType) {
                            this._priceType = this.options.priceType;
                        }
                        if (this.options.withEarnings) {
                            this._withEarnings = this.options.withEarnings;
                        }
                        if (this.options.language) {
                            this.language = this.options.language;
                        }
                        if (this.options.timezone) {
                            this.timezone = this.options.timezone;
                        }
                        if (this.options.defaultPriceRelativeInstrument) {
                            this.defaultPriceRelativeInstrument = this.options.defaultPriceRelativeInstrument;
                        }
                        if (this.options.defaultEventListeners) {
                            this._initEventListeners();
                        }
                        this.changeTimeZone(this.timezone);
                        this.changeLanguage(this.language);
                        this.stxx.chart.xAxis.formatter = function (labelDate, gridType, timeUnit, timeUnitMultiplier, defaultText) {
                            // For time units greater than a day (showing month or year), we leave the formatting to chart iq library
                            if (timeUnit === 86400000) {
                                return _this._dataHandler.formatDateTime(labelDate.getTime(), false);
                            }
                            else if (timeUnit < 86400000) {
                                return _this._dataHandler.formatDateTime(labelDate.getTime(), true);
                            }
                            // This formatting is used in the cross hair
                            if (!timeUnit && _this.stxx.chart.xAxis.activeTimeUnit) {
                                var intraday = _this.stxx.chart.xAxis.activeTimeUnit < 86400000;
                                return _this._dataHandler.formatDateTime(labelDate.getTime(), intraday);
                            }
                            return defaultText ? defaultText : labelDate;
                        };
                        this.stxx.chart.yAxis.priceFormatter = function (stx, panel, price) {
                            return _this._dataHandler.formatValue(price, { idNotation: _this._idNotation });
                        };
                        if (this._chartContentConfig.useCleanupGaps) {
                            // Enable gap cleanup to easier draw horizontal lines
                            this.stxx.cleanupGaps = 'carry';
                        }
                        return [4 /*yield*/, this.start()];
                    case 1:
                        hasStarted = _a.sent();
                        if (this._chartContentConfig.useSuggestedLegendRenderer) {
                            this.setLegendRenderer(null, true);
                        }
                        return [2 /*return*/, hasStarted];
                }
            });
        });
    };
    /**
     * Sets the price formatter of the chart data
     * To use the DEFAULT FORMATTER pass nothing sa formatter parameter
     * @param {Function|null} formatter
     * @returns {Function} formatter
     */
    ChartEngineContent.prototype.setPriceFormatter = function (formatter) {
        if (!formatter) {
            formatter = this._formatTransform();
        }
        this.stxx.formatPrice = formatter;
        // TODO: this might be an issue with multiple graphs if they use different formatters
        // @ts-ignore
        window.formatTransform = formatter;
        return formatter;
    };
    /**
     * Set the context of all UI elements
     * @param {HTMLElement} contextElement
     * @returns {any} UIContext
     */
    ChartEngineContent.prototype.setUIContext = function (contextElement) {
        this._UIContext = new CIQ.UI.Context(this.stxx, contextElement);
        // TODO: this won't work anymore if multiple charts are on one window
        // @ts-ignore
        window.UIContext = this._UIContext;
        // Make sure all bindings are set
        this._UIContext.buildReverseBindings();
        return this._UIContext;
    };
    /**
     * Set the current language uses
     * @param {SupportedLanguage} language
     */
    ChartEngineContent.prototype.setLanguage = function (language) {
        CIQ.I18N.setLanguage(this.stxx, language);
    };
    /**
     * Set the current language uses
     * @param {SupportedLocale} locale
     */
    ChartEngineContent.prototype.setLocale = function (locale) {
        CIQ.I18N.setLocale(this.stxx, locale);
    };
    /**
     * Create the helper for a Study Edit web component
     * @param {HTMLElement} studyEditElement
     * @returns {any} studyEdit
     */
    ChartEngineContent.prototype.createStudyEditHelper = function (studyEditElement) {
        if (!this._UIContext) {
            throw new Error('You have to set the UI context before trying to create UI helpers');
        }
        return new CIQ.UI.StudyEdit(null, this._UIContext, studyEditElement);
    };
    /**
     * Create a new Study Menu that can be used to add  a study to the chart
     * @param {HTMLElement} studyMenuElement
     * @param {string[]} enabledStudies
     * @returns {any} studyMenu
     */
    ChartEngineContent.prototype.createStudyMenuHelper = function (studyMenuElement, enabledStudies) {
        if (!this._UIContext) {
            throw new Error('You have to set the UI context before trying to create UI helpers');
        }
        var params = {
            alwaysDisplayDialog: { ma: true },
            excludedStudies: ChartEngineContent.getDisabledStudies(enabledStudies),
        };
        var studyMenu = new CIQ.UI.StudyMenu(studyMenuElement, this._UIContext, params);
        studyMenu.renderMenu();
        return studyMenu;
    };
    /**
     * Expose add study functionality of CIQ
     * @param {any} parameters
     * @returns {any} StudyDescriptor
     */
    ChartEngineContent.prototype.addStudy = function () {
        var _a;
        var parameters = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parameters[_i] = arguments[_i];
        }
        return (_a = CIQ.Studies).addStudy.apply(_a, __spreadArrays([this.stxx], parameters));
    };
    /**
     * Remove a previously added study
     * @param {any} studyDescriptor
     */
    ChartEngineContent.prototype.removeStudy = function (studyDescriptor) {
        CIQ.Studies.removeStudy(this.stxx, studyDescriptor);
    };
    /**
     * Set the span of the chart
     * @param {SpanBase} base
     * @param {number} multiplier
     * @param {Function} cb
     * @param {ContinuousZoomPeriodicity} periodicity
     */
    ChartEngineContent.prototype.setSpan = function (base, multiplier, cb, periodicity) {
        if (periodicity) {
            this.stxx.setSpan({ base: base, multiplier: multiplier, periodicity: periodicity }, cb);
        }
        else {
            this.stxx.setSpan({ base: base, multiplier: multiplier }, cb);
        }
    };
    /**
     * Set the type of the chart
     * @param {ChartType} chartType
     */
    ChartEngineContent.prototype.setChartType = function (chartType) {
        this.stxx.setChartType(chartType);
    };
    /**
     * Enable drawing mode for vector drawings
     * @param {VectorType} vectorType
     */
    ChartEngineContent.prototype.enableVectorDrawingMode = function (vectorType) {
        this.stxx.changeVectorType(vectorType);
    };
    /**
     * Disable drawing mode
     */
    ChartEngineContent.prototype.disableDrawingMode = function () {
        this.stxx.changeVectorType(null);
    };
    /**
     * If this is activated, auto disable drawing mode after something has been drawn
     * @param {boolean} enable
     */
    ChartEngineContent.prototype.setAutoDisableDrawingMode = function (enable) {
        var _this = this;
        if (enable) {
            this._eventListenerDrawing = this.stxx.addEventListener('drawing', function () {
                _this.disableDrawingMode();
            });
        }
        else if (this._eventListenerDrawing) {
            this.stxx.removeEventListener(this._eventListenerDrawing);
            this._eventListenerDrawing = null; // Reset listener
        }
    };
    /**
     * Get all the drawings currently drawn on the chart
     * @returns {Drawing[]} drawings
     */
    ChartEngineContent.prototype.getDrawings = function () {
        return this.stxx.drawingObjects;
    };
    /**
     * Remove a drawing from
     * @param {Drawing} drawing
     */
    ChartEngineContent.prototype.removeDrawing = function (drawing) {
        this.stxx.removeDrawing(drawing);
    };
    /**
     * Add a drawing to the chart and rerender the chart
     * @param {Drawing} drawing
     */
    ChartEngineContent.prototype.addDrawing = function (drawing) {
        this.stxx.addDrawing(drawing);
        this.stxx.changeOccurred('vector');
        this.stxx.draw();
    };
    /**
     * Redraw a drawing
     * @param {Drawing} drawing
     */
    ChartEngineContent.prototype.updateDrawing = function (drawing) {
        drawing.adjust();
    };
    /**
     * Get all annotations currently drawn on the chart
     * @returns {Drawing[]} annotations
     */
    ChartEngineContent.prototype.getAnnotations = function () {
        return this.getDrawings().filter(function (annotation) { return annotation.name === 'annotation'; });
    };
    /**
     * Draw a horizontal line on the chart
     * @param {number} value
     * @param {string} color
     * @param {number} width
     * @returns {Drawing} drawing
     */
    ChartEngineContent.prototype.drawHorizontalLine = function (value, color, width) {
        var _a, _b, _c;
        var from = ((_a = this.stxx) === null || _a === void 0 ? void 0 : _a.masterData) ? (_c = (_b = this.stxx) === null || _b === void 0 ? void 0 : _b.masterData[0]) === null || _c === void 0 ? void 0 : _c.Date : new Date(); // left border of the chart
        var options = {
            name: 'horizontal',
            pnl: 'chart',
            d0: from,
            v0: value,
            ptrn: 'solid',
            col: color,
            lw: width || 1,
        };
        var drawing = this.stxx.createDrawing('horizontal', options);
        this.stxx.changeOccurred('vector');
        this.stxx.draw();
        return drawing;
    };
    /**
     * Attach an event handler to a drawing
     * @param {Drawing} drawing
     * @param {DrawingEvent} event
     * @param {Function} handler
     * @returns {Drawing} drawing
     */
    ChartEngineContent.prototype.addEventHandlerDrawing = function (drawing, event, handler) {
        // Attach handler
        drawing[event] = handler;
        // Update chart
        this.updateDrawing(drawing);
        // Return modified drawing
        return drawing;
    };
    /**
     * Delete the handler and of the event and update the drawing
     * @param {Drawing} drawing
     * @param {DrawingEvent} event
     * @returns {Drawing} drawing
     */
    ChartEngineContent.prototype.removeEventHandlerDrawing = function (drawing, event) {
        // Detach event from drawing
        delete drawing[event];
        // Update chart
        this.updateDrawing(drawing);
        // Return modified drawing
        return drawing;
    };
    /**
     * Enable and set the legend of the chart
     * @param {Legend} legend
     */
    ChartEngineContent.prototype.setLegend = function (legend) {
        this.stxx.chart.legend = legend;
    };
    /**
     * Add a marker to the chart
     * @param {MarkerOptions} options
     * @returns {Marker} marker
     */
    ChartEngineContent.prototype.addMarker = function (options) {
        var marker = new CIQ.Marker(__assign({ stx: this.stxx }, options));
        this.stxx.draw();
        return marker;
    };
    /**
     * Remove a marker
     * @param {Marker} marker
     */
    ChartEngineContent.prototype.removeMarker = function (marker) {
        marker.remove();
    };
    /**
     * Append a new datapoint to a series
     * @param {PriceUpdate} priceUpdate
     * @param {number} idNotation
     */
    ChartEngineContent.prototype.appendDataPoint = function (priceUpdate, idNotation) {
        if (idNotation === this._idNotation) {
            this._sendUpdateMainInstrument(priceUpdate);
        }
        else {
            this._sendUpdateBenchmark(priceUpdate, idNotation);
        }
    };
    /**
     * Set custom legend renderer
     *
     * Set useSuggested to true and parse whatever as renderer if you want to use the suggested renderer
     * @see _suggestedLegendRenderer
     * @param {Function} renderer
     * @param {boolean} useSuggested
     */
    ChartEngineContent.prototype.setLegendRenderer = function (renderer, useSuggested) {
        var _this = this;
        if (useSuggested === void 0) { useSuggested = false; }
        if (useSuggested) {
            this.stxx.chart.legendRenderer = function () {
                var parameters = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    parameters[_i] = arguments[_i];
                }
                // @ts-ignore
                return ChartEngineContent.suggestedLegendRenderer.apply(ChartEngineContent, __spreadArrays(parameters, [_this._referenceData]));
            };
        }
        else {
            this.stxx.chart.legendRenderer = renderer;
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.getPNG = function () {
        if (this._containerDiv) {
            return html2canvas(this._containerDiv).then(function (canvas) {
                return canvas.toDataURL('image/png');
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.getCanvas = function () {
        if (this._containerDiv) {
            return html2canvas(this._containerDiv).then(function (canvas) {
                return canvas;
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.changeTheme = function (theme) {
        toggleBodyTheme(theme);
        if (this.stxx) {
            this.stxx.styles = {};
            this.stxx.chart.container.style.backgroundColor = '';
            this.stxx.updateListeners('theme');
            this.stxx.changeOccurred('theme');
            if (this.stxx.displayInitialized) {
                this.stxx.headsUpHR();
                this.stxx.clearPixelCache();
                this.stxx.updateListeners('theme');
                this.stxx.draw();
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.removeBenchmark = function (idNotation) {
        if (this._dataHandler.isBenchmarkSubscribed(idNotation)) {
            this._dataHandler.destroyBenchmarkSubscription(idNotation);
        }
        var symbol = (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase();
        this.stxx.removeSeries(symbol);
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.addBenchmark = function (idNotation, color, name) {
        var _this = this;
        if (!this._idNotation) {
            //if no initialized, just add as main instrument and initialize
            this.idNotation = idNotation;
        }
        else if (this._idNotation !== idNotation && this.stxx) {
            var symbol_1 = (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase();
            //we do not add twice
            if (!this._dataHandler.isBenchmarkSubscribed(idNotation)) {
                this._getReferenceData(idNotation).then(function (data) {
                    if (_this.stxx) {
                        if (Object.keys(_this.stxx.chart.series).length < 10) {
                            if (!color) {
                                //TODO improve color selection
                                color = 'red';
                            }
                            //TODO improve gaps and styles
                            var params = {
                                display: name || data.name,
                                symbolObject: { symbol: symbol_1 },
                                isComparison: true,
                                color: color,
                                data: { useDefaultQuoteFeed: true },
                                forceData: true,
                                gaps: {
                                    color: color,
                                    pattern: [3, 3],
                                },
                            };
                            _this.stxx.addSeries(symbol_1, params);
                        }
                    }
                });
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.changeLanguage = function (lang) {
        if (!lang) {
            lang = 'en';
        }
        if (lang !== this.language) {
            this.language = lang;
            if (CIQ && this.stxx) {
                CIQ.I18N.setLanguage(this.stxx, this.language, CIQ.I18N.translate, CIQ.I18N.csv, this._containerDiv);
                CIQ.I18N.setLocale(this.stxx, getLocale(this.language));
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.changeTimeZone = function (tz) {
        if (!tz) {
            this.timezone = 'Europe/London';
        }
        else {
            this.timezone = tz;
        }
        if (CIQ && CIQ.timeZoneMap && this.stxx) {
            var timeZone = mapTZ2ChartIQTZ(CIQ.timeZoneMap, this.timezone);
            if (timeZone) {
                CIQ.ChartEngine.defaultDisplayTimeZone = timeZone;
                this.stxx.setTimeZone(timeZone, timeZone);
                this.stxx.draw();
            }
        }
    };
    /**
     * @param {boolean?} persist
     */
    ChartEngineContent.prototype.clearContent = function (persist) {
        if (persist === void 0) { persist = false; }
        this.stxx.destroy();
        this.stxx = null;
        _super.prototype.clearContent.call(this, persist);
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.setRange = function (from, to, periodicity) {
        if (this.stxx) {
            if (periodicity) {
                this.stxx.setRange({
                    dtLeft: from,
                    dtRight: to,
                    periodicity: {
                        period: periodicity.period,
                        interval: periodicity.interval,
                        timeUnit: periodicity.timeUnit,
                    },
                });
            }
            else {
                this.stxx.setRange(from, to);
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype.eodFallback = function () {
        if (this.stxx && this.stxx.layout) {
            var periodicity = {
                period: 1,
                interval: 1,
                timeUnit: 'day',
            };
            if (this.stxx.layout.setSpan && this.stxx.layout.setSpan.base && this.stxx.layout.setSpan.multiplier) {
                this.stxx.setSpan({
                    base: this.stxx.layout.setSpan.base,
                    multiplier: this.stxx.layout.setSpan.multiplier,
                    periodicity: periodicity,
                });
            }
            else {
                this.stxx.setPeriodicity(periodicity);
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype._sendChangeInformationEvent = function () {
        if (this.stxx) {
            this._destroyPriceSubscription();
            for (var field in this.stxx.chart.series) {
                this._removeSeries()(field);
                this.stxx.removeSeries(field);
            }
            this._initOnceStxx();
            if (this._canSpanBeReset()) {
                this.stxx.newChart(this.symbol, null, null, null, {
                    span: {
                        base: this._chartContentConfig.spanBase,
                        multiplier: this._chartContentConfig.spanMultiplier,
                        maintainPeriodicity: this._chartContentConfig.maintainPeriodicity,
                    },
                });
            }
            else {
                this.stxx.newChart(this.symbol);
            }
            this._createPriceSubscription();
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype._sendCurrentRecordUpdateChartEvent = function (ohlc, idNotation, eventName) {
        if (eventName === void 0) { eventName = ''; }
        if (this.stxx) {
            if (ohlc && ohlc.length === 7 && this.stxx.chart && this.stxx.chart.masterData) {
                if (!ohlc[6]) {
                    ohlc[6] = 0;
                }
                if (this._idNotation !== idNotation) {
                    this._sendCurrentRecordBenchmark(ohlc, idNotation);
                }
                else {
                    this._sendCurrentRecordMainInstrument(ohlc);
                }
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype._sendUpdateChartEvent = function (update, idNotation, eventName) {
        if (eventName === void 0) { eventName = ''; }
        if (this.stxx) {
            if (this.stxx.chart && this.stxx.chart.masterData) {
                if (!update.volume) {
                    update.volume = 0;
                }
                if (this._idNotation !== idNotation) {
                    this._sendUpdateBenchmark(update, idNotation);
                }
                else {
                    this._sendUpdateMainInstrument(update);
                }
            }
        }
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype._sendErrorToChart = function (error, idNotation) {
        console.error(error);
    };
    /**
     * @inheritDoc
     */
    ChartEngineContent.prototype._initDefaultPriceRelInstrument = function (data) {
        var _this = this;
        if (data && CIQ.Studies.studyLibrary) {
            var defaultPriceRelativeInstrumentName_1 = this.defaultPriceRelativeInstrument + '';
            if (data['NameInstrumentShort']) {
                defaultPriceRelativeInstrumentName_1 = data['NameInstrumentShort'];
            }
            CIQ.Studies.studyLibrary['P Rel'].inputs[COMPARISON_SYMBOL] = this.defaultPriceRelativeInstrument;
            CIQ.Studies.studyLibrary['Perf Idx'].inputs[COMPARISON_SYMBOL] = this.defaultPriceRelativeInstrument;
            CIQ.Studies.studyLibrary['Beta'].inputs[COMPARISON_SYMBOL] = this.defaultPriceRelativeInstrument;
            var customInitPRel = function (stx, type, inputs, outputs, parameters, panel) {
                return _this._customRelativeInstrFN(stx, type, inputs, outputs, parameters, panel, 'P Rel ( ' + defaultPriceRelativeInstrumentName_1 + ' )');
            };
            var customInitPerfIndex = function (stx, type, inputs, outputs, parameters, panel) {
                return _this._customRelativeInstrFN(stx, type, inputs, outputs, parameters, panel, 'Perf Idx ( ' + defaultPriceRelativeInstrumentName_1 + ' )');
            };
            var customInitBeta = function (stx, type, inputs, outputs, parameters, panel) {
                return _this._customRelativeInstrFN(stx, type, inputs, outputs, parameters, panel, 'Beta ( ' + defaultPriceRelativeInstrumentName_1 + ' )');
            };
            //studies with comparison symbol are configured in the settings panel all together
            CIQ.Studies.studyLibrary['P Rel'].attributes = { COMPARISON_SYMBOL: { hidden: true } };
            CIQ.Studies.studyLibrary['Perf Idx'].attributes = { COMPARISON_SYMBOL: { hidden: true } };
            CIQ.Studies.studyLibrary['Beta'].attributes = { COMPARISON_SYMBOL: { hidden: true } };
            CIQ.Studies.studyLibrary['P Rel'].initializeFN = customInitPRel;
            CIQ.Studies.studyLibrary['Perf Idx'].initializeFN = customInitPerfIndex;
            CIQ.Studies.studyLibrary['Beta'].initializeFN = customInitBeta;
        }
    };
    /**f
     * @inheritDoc
     */
    ChartEngineContent.prototype._initChartEngine = function () {
        var _this = this;
        if (!this.defaultPriceRelativeInstrument) {
            return this._initStxx();
        }
        return this._getReferenceData(this.defaultPriceRelativeInstrument).then(function (data) {
            return _this._initStxx(data);
        });
    };
    /**
     * @param {any} params
     * @param {any} dataCallback
     * @private
     */
    ChartEngineContent.prototype._announceError = function (params, dataCallback) {
        console.error('Error while retrieving data. Please implement CIQ.alert in your application.');
        console.error(params);
        console.error(dataCallback);
        CIQ.alert(dataCallback); // default is alert, in sandboxes per default not permitted, should be overriden
    };
    /**
     * Launches the stxx, its market factory, the quote feed and initializes the default price instrument used in several studies
     *
     * @method _initStxx
     * @param {any?} data
     * @returns {Promise<boolean>}
     */
    ChartEngineContent.prototype._initStxx = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._initDefaultPriceRelInstrument(data);
            if (_this._idNotation) {
                _this._initOnceStxx();
                _this._restoreLayout();
                // Layout is not found from storage then it need to be rerendered
                if (!_this._chartLayout) {
                    _this.stxx.newChart(_this.symbol, null, null, function (err) {
                        if (err) {
                            reject(err);
                        }
                        else {
                            resolve(true);
                        }
                    });
                }
                else {
                    resolve(true);
                }
            }
        });
    };
    /**
     *  - Inits Market Factory
     *  - Attach Feed
     * @private
     */
    ChartEngineContent.prototype._initOnceStxx = function () {
        if (!this.initialized) {
            this.stxx.setMarketFactory(this._getMarketFactory());
            this.stxx.attachQuoteFeed(this.getQuoteFeed(), { refreshInterval: 0 });
            this.initialized = true;
        }
    };
    /**
     * Restores the layout from the local storage, chart settings service copies in the ls all settings on start up
     *
     * @private
     */
    ChartEngineContent.prototype._restoreLayout = function () {
        this._chartLayout = localStorage.getItem(this.chartSettingsKey);
        if (this._chartLayout) {
            this.stxx.importLayout(JSON.parse(this._chartLayout), { managePeriodicity: true });
        }
    };
    /**
     * Sends an update for a comparison series
     *
     * @param {PriceUpdate} update
     * @param {number} idNotation
     * @private
     */
    ChartEngineContent.prototype._sendUpdateBenchmark = function (update, idNotation) {
        this.stxx.updateChartData({
            Last: update.value,
            Volume: update.volume,
            DT: new Date(update.date),
        }, null, {
            secondarySeries: (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase(),
        });
    };
    /**
     * Sends the current record for a benchmark
     *
     * @param {any[]} ohlc
     * @param {number} idNotation
     * @private
     */
    ChartEngineContent.prototype._sendCurrentRecordBenchmark = function (ohlc, idNotation) {
        this.stxx.updateChartData({
            Last: ohlc[1],
            Volume: ohlc[5],
        }, null, {
            secondarySeries: (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase(),
        });
        this.stxx.updateChartData({
            Last: ohlc[2],
            Volume: 0,
        }, null, {
            secondarySeries: (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase(),
        });
        this.stxx.updateChartData({
            Last: ohlc[3],
            Volume: 0,
        }, null, {
            secondarySeries: (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase(),
        });
        this.stxx.updateChartData({
            Last: ohlc[4],
            Volume: 0,
        }, null, {
            secondarySeries: (idNotation + '#' + this.priceType + '#' + this.withEarnings).toLowerCase(),
        });
    };
    /**
     * Sends an update for the main instrument
     * @param {PriceUpdate} update
     * @private
     */
    ChartEngineContent.prototype._sendUpdateMainInstrument = function (update) {
        this.stxx.updateChartData({
            Last: update.value,
            Volume: update.volume,
            DT: new Date(update.date),
        }, null, { useAsLastSale: { aggregatedVolume: true } });
    };
    /**
     * Sends the current record for the main instrument
     *
     * @param {any[]} ohlc
     * @private
     */
    ChartEngineContent.prototype._sendCurrentRecordMainInstrument = function (ohlc) {
        this.stxx.updateChartData({
            Last: ohlc[1],
            Volume: ohlc[5],
        }, null, { useAsLastSale: { aggregatedVolume: true } });
        this.stxx.updateChartData({
            Last: ohlc[2],
            Volume: 0,
        }, null, { useAsLastSale: { aggregatedVolume: true } });
        this.stxx.updateChartData({
            Last: ohlc[3],
            Volume: 0,
        }, null, { useAsLastSale: { aggregatedVolume: true } });
        this.stxx.updateChartData({
            Last: ohlc[4],
            Volume: 0,
        }, null, { useAsLastSale: { aggregatedVolume: true } });
    };
    /**
     * Initializes stxx
     *
     * - Sets config
     * - Registers event listeners
     * - Changes timezone
     * - Changes language
     *
     * @private
     */
    ChartEngineContent.prototype._createStxx = function () {
        var _a, _b;
        this.stxx = new CIQ.ChartEngine({
            container: this._containerDiv,
            styles: this._chartContentConfig.styles,
            preferences: {
                currentPriceLine: this._chartContentConfig.currentPriceLine,
                labels: this._chartContentConfig.labels,
                whitespace: this._chartContentConfig.whitespace,
            },
            layout: {
                chartType: this._chartContentConfig.chartType,
                periodicity: this._chartContentConfig.periodicity,
                interval: this._chartContentConfig.interval,
                timeUnit: this._chartContentConfig.timeUnit,
                setSpan: {
                    base: this._chartContentConfig.spanBase,
                    multiplier: this._chartContentConfig.spanMultiplier,
                    maintainPeriodicity: this._chartContentConfig.maintainPeriodicity,
                },
            },
            chart: {
                legend: this._chartContentConfig.legend,
                xAxis: {
                    displayGridLines: this._chartContentConfig.xAxis.displayGridLines,
                    axisType: this._chartContentConfig.xAxis.type,
                    noDraw: this._chartContentConfig.xAxis.noDraw,
                },
                yAxis: {
                    displayGridLines: this._chartContentConfig.yAxis.displayGridLines,
                    drawCurrentPriceLabel: this._chartContentConfig.yAxis.drawCurrentPriceLabel,
                    goldenRatioYAxis: this._chartContentConfig.yAxis.goldenRatio,
                    position: this._chartContentConfig.yAxis.position,
                    noDraw: this._chartContentConfig.yAxis.noDraw,
                },
            },
            controls: {
                mSticky: this._chartContentConfig.mSticky,
                drawOk: this._chartContentConfig.drawOk,
            },
            resizeDetectMS: this._chartContentConfig.resizeDetectMS,
            xAxisAsFooter: this._chartContentConfig.xAxis.asFooter,
            xaxisHeight: this._chartContentConfig.xAxis.height,
        });
        this.readySub.next(this.stxx);
        // Only set range when it is needed, otherwise it will override previous span
        if (this._chartContentConfig.rangeFrom !== null || this._chartContentConfig.rangeTo !== null) {
            this.stxx.layout.range = {
                dtLeft: this._chartContentConfig.rangeFrom,
                dtRight: this._chartContentConfig.rangeTo,
            };
        }
        /**
         * Enable continuous zoom if specified
         * Use either provided options or if non were provided use the default options
         */
        if ((_b = (_a = this._chartContentConfig) === null || _a === void 0 ? void 0 : _a.continuousZoom) === null || _b === void 0 ? void 0 : _b.enabled) {
            var options = this._chartContentConfig.continuousZoom.options ||
                this._chartContentConfig.continuousZoomDefaultOptions;
            new CIQ.ContinuousZoom(__assign({ stx: this.stxx }, options));
        }
        this.stxx.callbacks.layout = this._saveLayout;
        this.stxx.callbacks.symbolChange = this._saveLayout;
    };
    /**
     * If the resetSpan flag is set to true and the span fields are properly field returns true, false otherwise
     * @returns {boolean}
     * @private
     */
    ChartEngineContent.prototype._canSpanBeReset = function () {
        return (this._chartContentConfig.resetSpan === true &&
            this._chartContentConfig.spanMultiplier !== null &&
            this._chartContentConfig.spanBase !== null &&
            this._chartContentConfig.periodicity !== null &&
            this._chartContentConfig.timeUnit !== null);
    };
    /**
     * Initialise all event handlers
     * @private
     */
    ChartEngineContent.prototype._initEventListeners = function () {
        var _this = this;
        /**
         * Drawing on click event
         */
        this._addEventListener('drawingEdit', function (_a) {
            var drawing = _a.drawing;
            if (drawing.onClick) {
                drawing.onClick(drawing);
            }
            else {
                // Default behaviour
                _this.removeDrawing(drawing);
            }
        });
    };
    /**
     * Add event listener to the chart
     * @param {ChartEvent} event
     * @param {Function} callback
     */
    ChartEngineContent.prototype._addEventListener = function (event, callback) {
        this.stxx.addEventListener(event, callback);
    };
    return ChartEngineContent;
}(AbstractChartContent));
export { ChartEngineContent };
//# sourceMappingURL=chart-engine-content.js.map